import React from 'react';
import { useSelector } from 'react-redux';
import { nocModeSelector } from '@store/noc/base/selectors';
import { NOC_MODE_TRENDS, NOC_MODE_FILTERS } from '@utils/constants';
import TrendsTable from './TrendsTable';
import FilterTable from './FilterTable';
import { LoadingWrapper } from './styled';
import { useSetError } from '@hooks/useSetError';

// wrapper to switch table based on mode change
function MetricTable() {
  useSetError();
  const mode = useSelector(nocModeSelector);
  let table = <LoadingWrapper isLoading showError={false} />;

  if (mode === NOC_MODE_TRENDS) {
    table = <TrendsTable />;
  } else if (mode === NOC_MODE_FILTERS) {
    table = <FilterTable />;
  }

  return table;
}

export default MetricTable;
